var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page noselect" },
    [
      _c(
        "v-container",
        { attrs: { "grid-list-md": "" } },
        [
          _c("h2", { staticClass: "text-center mt-7" }, [
            _vm._v("Verwendung von Cookies"),
          ]),
          _c(
            "p",
            [
              _vm._v(
                "Hier findest Du eine Übersicht über alle verwendeten Cookies. Einige von ihnen sind notwendig, während uns andere dabei helfen, unsere Inhalte und Werbung entsprechend Deiner Interessen anzuzeigen. Nähere Informationen zur Datenverarbeitung findest du in unserer "
              ),
              _c("router-link", { attrs: { to: { name: "Datenschutz" } } }, [
                _vm._v("Datenschutzerklärung "),
              ]),
            ],
            1
          ),
          _c("p", [
            _vm._v(" Entsprechend denen von Ihnen festgelegten "),
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  "&click": function ($event) {
                    return _vm.clickDsgvo.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Datenschutzeinstellungen")]
            ),
            _vm._v(
              " geben wir Informationen zur Verwendung unserer Webseite an unsere Partner für soziale Medien, Werbung und Analysen weiter. Unsere Partner führen diese Informationen möglicherweise mit weiteren Daten zusammen, die du im Rahmen Deiner Nutzung der jeweiligen Dienste gesammelt hast. "
            ),
          ]),
          _c("div", { staticClass: "spacer-25" }),
          _c(
            "v-expansion-panels",
            { attrs: { hover: true } },
            [
              _c(
                "v-expansion-panel",
                { key: "1" },
                [
                  _c("v-expansion-panel-header", [
                    _c("h4", { staticClass: "text-none dialogText" }, [
                      _vm._v("Notwendige Cookies"),
                    ]),
                  ]),
                  _c("v-expansion-panel-content", [
                    _c("div", { staticClass: "cookies" }, [
                      _c("table", { staticClass: "maxw cookieTable" }, [
                        _c("tr", [
                          _c("td", [_vm._v("Name")]),
                          _c("td", [_vm._v("Payone Analyse-Cookies")]),
                        ]),
                        _c("tr", [
                          _c("td", [_vm._v("Anbieter")]),
                          _c("td", [_vm._v("PAYONE GmbH")]),
                        ]),
                        _c("tr", [
                          _c("td", [_vm._v("Zweck")]),
                          _c("td", [
                            _vm._v(
                              "Unterstützung der sicheren Durchführung von Online-Zahlungen, Betrugserkennung und Verbesserung des Zahlungsprozesses "
                            ),
                          ]),
                        ]),
                        _c("tr", [
                          _c("td", [_vm._v("Details")]),
                          _c("td", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  target: "_blank",
                                  href: "https://www.payone.com/DE-de/datenschutz",
                                },
                              },
                              [
                                _vm._v(
                                  " https://www.payone.com/DE-de/datenschutz "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "spacer-15" }),
          _c(
            "v-expansion-panels",
            { attrs: { hover: true } },
            [
              _c(
                "v-expansion-panel",
                { key: "1" },
                [
                  _c("v-expansion-panel-header", [
                    _c("h4", { staticClass: "text-none dialogText" }, [
                      _vm._v("Statistiken"),
                    ]),
                  ]),
                  _c("v-expansion-panel-content", [
                    _c("div", { staticClass: "cookies" }, [
                      _c("table", { staticClass: "maxw cookieTable" }, [
                        _c("tr", [
                          _c("td", [_vm._v("Name")]),
                          _c("td", [_vm._v("Google Analytics")]),
                        ]),
                        _c("tr", [
                          _c("td", [_vm._v("Anbieter")]),
                          _c("td", [_vm._v("Google LLC")]),
                        ]),
                        _c("tr", [
                          _c("td", [_vm._v("Zweck")]),
                          _c("td", [
                            _vm._v(
                              "Cookie von Google zur Analyse der Webseitenverwendung. Erzeugt statistische Daten darüber, wie der Besucher die Webseite nutzt. "
                            ),
                          ]),
                        ]),
                        _c("tr", [
                          _c("td", [_vm._v("Details")]),
                          _c("td", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  target: "_blank",
                                  href: "https://policies.google.com/privacy?hl=de",
                                },
                              },
                              [
                                _vm._v(
                                  "https://policies.google.com/privacy?hl=de"
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "spacer-15" }),
          _c("div", { staticClass: "spacer-25" }),
          _c("div", { staticClass: "spacer-15" }),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "okBtn btn-df text-none",
                  attrs: { rounded: "" },
                  nativeOn: {
                    "&click": function ($event) {
                      $event.stopPropagation()
                      return _vm.clickDsgvo.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(" Datenschutzeinstellungen ")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "spacer-25" }),
          _c("div", { staticClass: "spacer-25" }),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("router-link", { attrs: { to: { name: "Datenschutz" } } }, [
                _vm._v("Datenschutzerklärung"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }